import * as React from "react";
const SvgShrinkIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", "data-icon": "shrink", role: "img", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.347 3.807-.008 6.074 6.075-.007a1 1 0 0 1 1.004 1.004 1 1 0 0 1-1.005 1.004h-7.07a1 1 0 0 1-1.005-1.004V3.807a1.004 1.004 0 0 1 2.009 0M9.878 20.415l.007-6.074-6.074.007a1 1 0 0 1-1.004-1.004A1 1 0 0 1 3.81 12.34h7.07a1 1 0 0 1 1.005 1.004v7.07a1.004 1.004 0 0 1-2.008 0Z" }));
export default SvgShrinkIcon;
